const UPDATES = [
  {
    date: '2024.12',
    title: '版本 v3.8.2 正式发布',
    desc: '优化播放器内核，提升4K视频解码效率，修复部分机型闪退问题，新增手势音量调节功能。',
    tag: '版本更新',
  },
  {
    date: '2024.11',
    title: '片源库突破30,000部',
    desc: '经过持续内容扩充，平台高清影视资源正式突破3万部大关，涵盖更多海外剧集与纪录片内容。',
    tag: '内容里程碑',
  },
  {
    date: '2024.10',
    title: '智能推荐算法上线',
    desc: '基于观看历史的个性化推荐系统正式启用，能更精准地为用户推送感兴趣的影视内容，提升发现效率。',
    tag: '功能升级',
  },
  {
    date: '2024.09',
    title: '投屏功能全面升级',
    desc: '支持DLNA与AirPlay双协议投屏，适配主流智能电视品牌，手机一键投屏至大屏畅享家庭影院体验。',
    tag: '功能升级',
  },
  {
    date: '2024.08',
    title: '离线下载速度提升50%',
    desc: '优化多线程下载引擎，WiFi环境下离线缓存速度大幅提升，批量下载更高效省时。',
    tag: '性能优化',
  },
  {
    date: '2024.07',
    title: '多线路智能切换2.0',
    desc: '全新升级的播放线路调度算法，实时检测各线路响应速度，自动切换最优播放源，告别缓冲等待。',
    tag: '性能优化',
  },
  {
    date: '2024.06',
    title: '用户界面全新改版',
    desc: '采用全新视觉设计语言，优化首页布局与分类导航，提升操作流畅度与视觉舒适度，获得用户一致好评。',
    tag: '体验升级',
  },
  {
    date: '2024.05',
    title: '91影视看片品牌正式上线',
    desc: '平台完成品牌升级，以"91影视看片"为统一品牌面向用户，确立"免费、高清、全品类"的核心定位。',
    tag: '品牌升级',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
            <i className="ri-timer-line mr-1"></i>动态快讯
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            91影视看片更新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            追踪平台功能迭代、内容扩充与版本更新，记录每一次进步
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] md:left-[27px] top-2 bottom-2 w-0.5 bg-background-300"></div>

          <div className="space-y-8">
            {UPDATES.map((item, i) => (
              <div key={i} className="relative flex gap-5 md:gap-8">
                <div className="relative z-10 w-10 h-10 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-50 border-2 border-primary-200 shrink-0">
                  <div className={`w-2.5 h-2.5 md:w-3 md:h-3 rounded-full ${i === 0 ? 'bg-primary-500' : 'bg-background-300'}`}></div>
                </div>
                <div className="flex-1 bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/60">
                  <div className="flex flex-wrap items-center gap-3 mb-2">
                    <span className="text-xs md:text-sm font-medium text-foreground-500">{item.date}</span>
                    <span className="px-2.5 py-0.5 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}